import { useQuery } from '@tanstack/react-query';
import { getVendorSettings } from 'packages/tackle-api/src/co-sell-msft';

const useMsftVendorSettings = () => {
  const query = useQuery({
    queryKey: ['vendorSettings'],
    queryFn: () => getVendorSettings(),
    staleTime: Infinity,
  });

  return query;
};

export default useMsftVendorSettings;
